/* eslint-disable no-script-url */

import React from 'react';

import { getContadorDetalleMes } from '../../actions/getContadorDetalleMes';

import { setCuentaCodigo, setCuentaDetalleContador, resetCuentaDetalleContador, setPeriodo, resetPeriodo, setMes, resetMes, setTipoRegistro } from '../../actions'
import { fetchingRptCtasDetallesMes } from '../../actions'

import CircularProgress from '@material-ui/core/CircularProgress';
import Title from './Title';

import { store } from '../../store';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';


const cargarDatos = (props) => {

    var urlParams = "";
    urlParams += "/" + encodeURIComponent(Object.values(props.cuentaDetalleContador).join(''));
    urlParams += "/" + encodeURIComponent(Object.values(props.periodo).join(''));
    //urlParams += "/" + encodeURIComponent(Object.values(props.mes).join(''));

    const info = props.getContadorDetalleMes(urlParams);
    return info;
};


const filtros = (props) => {

    if (props.terceroCuentas.resp === "ok" && Object.values(props.cuentaCodigo).join('') === '') {

        if (!(props.terceroCuentas.cta.length === 0)) {
            const lstCuentasFiltro = props.terceroCuentas.filtros;

            if (!(lstCuentasFiltro.length === 0)) {
                const f1 = lstCuentasFiltro[0].cuentaCodigo;
                const f2 = lstCuentasFiltro[0].contadores[0].cuentaDetalleContador;
                const f3 = lstCuentasFiltro[0].contadores[0].periodos[0].periodo;
                const f4 = lstCuentasFiltro[0].contadores[0].periodos[0].meses[0].mes;
                //const f5 = lstCuentasFiltro[0].contadores[0].periodos[0].meses[0].dias[0].dia;

                store.dispatch(setCuentaCodigo(f1));
                store.dispatch(setCuentaDetalleContador(f2));
                store.dispatch(setPeriodo(f3));
                //store.dispatch(setMes(f4));
                store.dispatch(resetMes());

                store.dispatch(setTipoRegistro('imp'));
                store.dispatch(fetchingRptCtasDetallesMes());
            }
        }
    }

}

const tabla = (props) => {

    const { classes } = props;
    //debugger;

    if (!(props.terceroCuentas === undefined)) {
        if (props.terceroCuentas.cta.length === 0) {
            return (
                <Paper className={classes.paper}>
                    <p>Sin datos...</p>
                </Paper>
            );
        }
    }
    else {
        return (
            <Paper className={classes.paper}>
                <p>Sin datos...</p>
            </Paper>
        );
    }

    const lstCuentasFiltro = props.terceroCuentas.filtros;
    const selCta = Object.values(props.cuentaCodigo).join('');

    var lstContadoresFiltro = [];
    if (selCta === '') {
        // no se ha seleccionado cuenta
    }
    else {
        const lstContadores = lstCuentasFiltro.find(cuenta => cuenta.cuentaCodigo === selCta).contadores;
        lstContadoresFiltro = [...lstContadoresFiltro, ...lstContadores];
    }

    const selContador = Object.values(props.cuentaDetalleContador).join('');

    var lstPeriodosFiltro = [];
    if (selContador === '') {
        // no se ha seleccionado contador...
    }
    else {
        const lstPeriodos = lstContadoresFiltro.find(cuenta => cuenta.cuentaDetalleContador === selContador).periodos;
        lstPeriodosFiltro = [...lstPeriodosFiltro, ...lstPeriodos];
    }

    const selPeriodo = Object.values(props.periodo).join('');

    var lstMesesFiltro = [];
    if (selPeriodo === '') {
        // no se ha seleccionado contador...
    }
    else {
        const lstMeses = lstPeriodosFiltro.find(cuenta => cuenta.periodo === selPeriodo).meses;
        lstMesesFiltro = [...lstMesesFiltro, ...lstMeses];
    }

    const selMes = Object.values(props.mes).join('');

    const selTipo = Object.values(props.tipoRegistro).join('');

    const frmEstado = props.apiFetch.RptCtasDetallesMes === undefined ? 'init' : props.apiFetch.RptCtasDetallesMes;

    if (frmEstado === 'fetching') {
        cargarDatos(props);
    }

    const contadorDetalleMes = props.apiFetch.getContadorDetalleMes === undefined ? [] : props.apiFetch.getContadorDetalleMes;

    return (
        <Paper className={classes.paper}>
            <Title>MATRIZ DETALLADA x MESES (kWh)</Title>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="selectCuenta">Cuenta</InputLabel>
                        <Select
                            value={selCta}
                            onChange={handleChange}
                            inputProps={{
                                name: 'cuentaCodigo',
                                id: 'selectCuenta',
                            }}>
                            {lstCuentasFiltro.map(row => (
                                <MenuItem value={row.cuentaCodigo} key={row.cuentaCodigo}>{row.cuentaCodigo}</MenuItem>

                            ))}
                        </Select>
                    </FormControl>

                </Grid>
                <Grid item xs={12} sm={2}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="selectContador">Contador</InputLabel>
                        <Select
                            value={selContador}
                            onChange={handleChange}
                            inputProps={{
                                name: 'cuentaDetalleContador',
                                id: 'selectContador',
                            }}>
                            {lstContadoresFiltro.map(row => (
                                <MenuItem value={row.cuentaDetalleContador} key={row.cuentaDetalleContador}>{row.cuentaDetalleContador}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={2}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="selectPeriodo">Periodo</InputLabel>
                        <Select
                            value={selPeriodo}
                            onChange={handleChange}
                            inputProps={{
                                name: 'periodo',
                                id: 'selectPeriodo',
                            }}>
                            {lstPeriodosFiltro.map(row => (
                                <MenuItem value={row.periodo} key={row.periodo}>{row.periodo}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={2}>
                    <div>{frmEstado === 'fetching' ? <CircularProgress className={classes.progress} /> : ''}</div>
                </Grid>
            </Grid>

            {frmEstado === 'done' ? (
                <React.Fragment>

                    <Table size="small" >
                        <TableHead>
                            <TableRow>
                                <TableCell>Mes</TableCell>
                                <TableCell align="right">Importado </TableCell>
                                <TableCell align="right">Exportado</TableCell>
                                <TableCell align="right">Valor excedente</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contadorDetalleMes.map(row => (
                                <TableRow key={row.mes}>
                                    <TableCell>{row.mesNombre}</TableCell>
                                    <TableCell align="right">{Number.parseFloat(row.cuentaDetalleImp).toFixed(2)}</TableCell>
                                    <TableCell align="right">{Number.parseFloat(row.cuentaDetalleExp).toFixed(2)}</TableCell>
                                    {gridRows(row)}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </React.Fragment>
            ) : ''}

        </Paper>
    );
}

const gridRows = (row) => {

    const formatterPeso = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    })

    var r = Number.parseFloat(row.cuentaDetalleValoracion).toFixed(2);
    if (isNaN(r)) {
        r = '0';
    }

    return (
        <TableCell align="right">{formatterPeso.format(r)}</TableCell>
    );
}


const mostrarCargando = props => {
    const { classes } = props;

    if (props.terceroCuentas.resp !== "loading") {
        //cargarDatos(props);
    }

    return (
        <Paper className={classes.paper}>
            <Title>MATRIZ DETALLADA x MESES (kWh)</Title>
            <div><CircularProgress className={classes.progress} /></div>
        </Paper>
    );
}

function handleChange(event) {
    console.log(event.target.name + " -->" + event.target.value);
    if (event.target.name === "cuentaCodigo") {
        store.dispatch(setCuentaCodigo(event.target.value));
        store.dispatch(resetCuentaDetalleContador());
        store.dispatch(resetPeriodo());
        store.dispatch(resetMes());
        //debugger;
    }
    if (event.target.name === "cuentaDetalleContador") {
        store.dispatch(setCuentaDetalleContador(event.target.value));
        store.dispatch(resetPeriodo());
        store.dispatch(resetMes());
    }
    if (event.target.name === "periodo") {
        store.dispatch(setPeriodo(event.target.value));

        store.dispatch(resetMes());
        store.dispatch(fetchingRptCtasDetallesMes());
    }
    /*
    if (event.target.name === "mes") {
        store.dispatch(setMes(event.target.value));
        store.dispatch(fetchingRptCtasDetallesMes());
    }
    if (event.target.name === "tipo") {
        store.dispatch(setTipoRegistro(event.target.value));
        store.dispatch(fetchingRptCtasDetallesMes());
    }
    */
}

const RptCtasDetallesMes = props => {

    filtros(props);

    return (
        (props.terceroCuentas.resp === 'ok') ? tabla(props) : mostrarCargando(props));
};

const mapStateToProps = function (state) {
    return {
        terceroCuentas: state.terceroCuentas,
        terceroID: state.auth.terceroID,
        cuentaCodigo: state.cuentaCodigo,
        cuentaDetalleContador: state.cuentaDetalleContador,
        periodo: state.periodo,
        mes: state.mes,
        tipoRegistro: state.tipoRegistro,
        apiFetch: state.apiFetch,

    }
}


export default connect(mapStateToProps, { getContadorDetalleMes })(RptCtasDetallesMes);


